import "./bootstrap";

import { createApp, markRaw } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./api.js";
import { piniaPersist } from "@/utils/pinia-persist";
import "@/hooks/session-expired";
import "@/hooks/app";

import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";

dayjs.extend(customParseFormat);

const app = createApp(App);
const pinia = createPinia();

pinia.use(piniaPersist);
app.use(pinia);
app.use(router);

app.mount("#app");
